import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalContent: ({ spacing }) => css`
    margin: ${spacing.sm} 0 ${spacing.sm} 0;
  `,

  subtitle: css`
    display: flex;
    flex-direction: column;
  `,

  dependentSection: css`
    display: flex;
    flex-direction: column;
  `,

  dependentList: css`
    display: flex;
    flex-direction: column;
  `,

  dependentListItem: ({ spacing }) => css`
    display: flex;
    align-items: center;
    text-align: center;
    gap: ${spacing.xxs};
  `,

  tag: () => css`
    display: flex;
    align-items: center;
    margin-top: -4px;
  `,

  listTitle: ({ spacing }) => css`
    display: flex;
    align-items: center;
    gap: ${spacing.xxs};
    margin-top: ${spacing.xs};
  `,
})

export { useStyles }
